<div class="d-flex">
    <h2 class="h2">{{messages.length}} New messages</h2>
    <span class="body-smaller ms-auto mt-2"><span class="icon-text">Go To Message Center</span>
    <a [routerLink]="['/app/message-center']" class="btn btn-link p-0 color-link-primary" style="margin-top: -15px;"><mat-icon title="Go To Message Center">open_in_new</mat-icon></a></span>
</div>
<mat-progress-bar mode="indeterminate" *ngIf="isLoaderMsg"></mat-progress-bar>
<ng-container *ngIf="messages && messages.length > 0;else elseBlock">
    <div style="max-height: 180px;overflow: scroll;">
        <div *ngFor="let item of messages.slice(0, 3);">
            <app-dashboard-item [message]="item"></app-dashboard-item>
        </div>
    </div>
</ng-container>
<ng-template #elseBlock>
    <mat-card><mat-card-content class="text-center">No new messages</mat-card-content></mat-card>
</ng-template>
